import { render, staticRenderFns } from "./GameEventEdit.vue?vue&type=template&id=748a180c&"
import script from "./GameEventEdit.vue?vue&type=script&lang=js&"
export * from "./GameEventEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports